// extracted by mini-css-extract-plugin
export default {"container":"ServerErrorLabel_container__dWf1P","text":"ServerErrorLabel_text__h+gt2"};